module.exports = __webpack_public_path__ + "static/img/online_01.f6c424f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2022/corona/online_01.png
// module id = U5Hj
// module chunks = 0